import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { DatatableComponent, isNullOrUndefined } from '@swimlane/ngx-datatable';
import { Router, NavigationExtras } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';

import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';

import { ActivityStoreFacade } from '../../../common/facade/ActivityStoreFacade';
import { CatalogDetFacade } from '../../../common/facade/CatalogDetFacade';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { DateFormatPipe } from '../../../common/util/date-format.pipe';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { Organization } from '../../../common/model/Organization';

@Component({
    selector: 'app-reportgral',
    templateUrl: './report.component.html'
})

export class ReportComponent implements OnInit {
    // region Properties and Attributes
    @ViewChild('tableActivities') tableActivities: DatatableComponent;

    titleActivitiesReport = res.ActivitiesReport;
    lblDownload = res.Download;
    lblActivityType = res.ActivityType;
    lblSelectAnOption = res.SelectAnOption;
    lblSearch = res.Search;
    lblInvoice = res.Reference;
    lblActivityName = res.ActivityName;
    lblStartDate = res.StartDate;
    lblEndDate = res.EndDate;
    lblProgress = res.Progress;
    lblStatus = res.Status;
    res = res;
    messagesTable: any = {
        emptyMessage: '',
        totalMessage: ''
    };
    isSpanish = true;

    lsTaskType: any[] = [];
    loading = false;
    messageLoader = '';
    message = '';
    modalTitle = '';
    public catDetTaskTypeId = -1;
    public txtSearch = '';
    public backToVisible = false;
    public rows: any = [];
    private _filteredData = [];

    // alert
    alerts: any[] = [];
    public TenantId = 0;
    botonEnable: boolean;

    lstOrganization: Organization[] = [];
    availableOrganizations: Organization[] = [];
    selectedOrganizations: Organization[] = [];
    public organizationSelected: any[] = [];
    strOrganizationSelected: string;
    organizationId: string;
    // region Constructor
    constructor(
        @Inject(SESSION_STORAGE) private storage: WebStorageService,
        private _facade: ActivityStoreFacade,
        private _facadeCatDet: CatalogDetFacade,
        private _router: Router,
        private _route: ActivatedRoute,
        private _datePipe: DatePipe,
        private _excel: ExcelUtility,
        private _dateFormatPipe: DateFormatPipe,
        public strings: Strings
    ) {
        this.storage.set('moduleUrl', this._router.url);
    }

    // region EventHandlers
    ngOnInit() {
        this.isSpanish = this.strings.getLanguageIsSpanish();
        this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
        this.messagesTable.totalMessage = 'Total';

        this.loading = true;
        this.TenantId = this.strings.getTenant();
        this.availableOrganizations = this.strings.getAvailableOrganizations();
        this.lstOrganization = this.availableOrganizations.filter(Orga => Orga.tenantId == this.TenantId);
        this._facadeCatDet.Get(3).subscribe(result => {
            if (result.completed) {
                result.data.forEach(element => {
                    if (element.catDetId !== 110 && element.catDetId !== 112 && element.catDetId !== 113 && element.catDetId !== 114) {
                      this.lsTaskType.push(element);
                    }
                  });

                this._route.queryParams.subscribe(params => {
                    if (params['pCtDtTskTypd'] !== undefined) {
                        this.catDetTaskTypeId = Number(params['pCtDtTskTypd']);
                    }
                    if (params['pRqrd'] !== undefined) {
                        this.txtSearch = '-' + params['pRqrd'].substr(4, 4);
                    }

                    if (params['orgId'] !== undefined) {
                        this.strOrganizationSelected = params['orgId']
                        this.organizationId = this.strOrganizationSelected;
                        this.organizationSelected = this.lstOrganization.filter((org) =>
                            this.organizationId.includes(org.organizationId)
                          );
                          this.selectedOrganizations = this.lstOrganization;
                          this.botonEnable = true;
                    }
                });

                if (this.catDetTaskTypeId > 0) {
                    this.onTaskTypeChange();
                }
            }
            this.loading = false;
        }, error => {
            this.addAlert('<strong>' + error + '</strong>', 'danger');
            this.loading = false;
        });
    }

    onTaskTypeChange() {
        this.loading = true;
        this.messageLoader = 'Obteniendo Actividades';
        let language = 0;
        if (!this.isSpanish) {
            language = 1;
        }
        this._facade.GetSummary(this.catDetTaskTypeId, language).subscribe(result => {
            if (result.completed) {
                this.rows = result.data.filter(org => this.strOrganizationSelected.includes(org.organizationId));
                this._filteredData = result.data;
                if (this.txtSearch !== '') {
                    this.filterData(this.txtSearch);
                }
            }
            this.loading = false;
        }, error => {
            this.addAlert('<strong>' + error + '</strong>', 'danger');
            this.loading = false;
        });
    }

    onViewDetail(code: string) {
        const item = this.rows.find(x => x.code === code);
        const navigationExtras: NavigationExtras = {
            queryParams: {
                'pCd': code,
                'pRqrd': this._datePipe.transform(item.requiredDate, 'yyyyMMdd'),
                'pCtDtTskTypd': item.catDetTaskTypeId,
                'orgId': this.strOrganizationSelected,
                'pTi': (isNullOrUndefined(code.split('-')[0]) ? 0 : code.split('-')[0])
            }
        };

        this._router.navigate(['views/task/report/store'], navigationExtras).then((e) => {
            if (e) {
                console.log('Navigation is successful!');
            } else {
                console.log('Navigation has failed!');
            }
        });
    }

    updateFilter(event) {
        // get the value of the key pressed and make it lowercase
        this.txtSearch = event.target.value.toLowerCase();
        // get the amount of columns in the table
        this.filterData(this.txtSearch);
    }

    private filterData(val) {
        // let colsAmt = 20;

        // get the key names of each column in the dataset
        const keys = Object.keys(this._filteredData[0]);

        // assign filtered matches to the active datatable
        this.rows = this._filteredData.filter(function (item) {
            // iterate through each row's column data
            for (let i = 0; i < keys.length; i++) {

                if (item[keys[i]] != null &&
                    (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
                    return true;
                }
            }
        });

        this.tableActivities.offset = 0;
    }
    // añadir alert
    addAlert(message: String, type: String): void {
        this.alerts = [];
        this.alerts.push({
            type: type,
            msg: message
        });
    }

    // cerrar alert
    onClosed(dismissedAlert: AlertComponent): void {
        this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
    }

    downloadLayout() {
        if (this.rows.length > 0) {
            const data: any = [];
            this.rows.forEach(row => {
                let info: any;
                if (this.isSpanish) {
                    info = {
                        [this.strings.GetText(res.Reference)] : row.code,
                        [this.strings.GetText(res.ActivityName)] : row.title,
                        [this.strings.GetText(res.StartDate)] : this._datePipe.transform(row.requiredDate, 'dd/MM/yyyy'),
                        [this.strings.GetText(res.EndDate)] :  this._datePipe.transform(row.completedDate, 'dd/MM/yyyy'),
                        [this.strings.GetText(res.Progress)] : row.percentComplete,
                        [this.strings.GetText(res.Status)] : row.status
                    };
                } else {
                    info = {
                        [this.strings.GetText(res.Reference)] : row.code,
                        [this.strings.GetText(res.ActivityName)] : row.title,
                        [this.strings.GetText(res.StartDate)] : this._datePipe.transform(row.requiredDate, 'MM/dd/yyyy'),
                        [this.strings.GetText(res.EndDate)] :  this._datePipe.transform(row.completedDate, 'MM/dd/yyyy'),
                        [this.strings.GetText(res.Progress)] : row.percentComplete,
                        [this.strings.GetText(res.Status)] : row.status
                    };
                }
                data.push(info);
            });
            this._excel.exportAsExcelFile(data, 'data');
        } else {
            this.addAlert(this.strings.GetText(res.AlertSelectActivityFirst), 'danger');
        }
    }
    
    onChangeOrganization(selectedOrganization: any[]) {
        this.catDetTaskTypeId=-1
        this.selectedOrganizations = selectedOrganization;
        this.strOrganizationSelected = this.selectedOrganizations.map(e => e.organizationId).join(',');
        if (selectedOrganization.length > 0) {
            this.botonEnable = true;
        }
        else {
            this.botonEnable = false;
        }
    }
}
